// FILE: src/config.js (FULLY UPDATED)

const REACT_APP_BACKEND_API = process.env.REACT_APP_BACKEND_API || "http://localhost:8000";
const REACT_APP_GOOGLE_FONT = process.env.REACT_APP_GOOGLE_FONT;

// Export the constants so they can be imported elsewhere
export {
  REACT_APP_BACKEND_API,
  REACT_APP_GOOGLE_FONT
};